import { createSelector } from 'reselect';

import { IEstimate } from '@epi-models/containers/LoadCompanyAccount';

const transactionEstimationSelector = state => state.apiTransactionEstimation;

export const originalTotalSuggestedTransferSelector = createSelector(
  transactionEstimationSelector,
  (state): number => state.originalTotalSuggestedTransfer
);

export const estimationSelector = createSelector(
  transactionEstimationSelector,
  (state): IEstimate => state.estimation
);

export const isTransferSuggestedSelector = createSelector(
  estimationSelector,
  estimation => ((!!estimation && estimation.totalSuggestedTransfer) || 0) > 0
);
